import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { Route as ConnectTwoFaRoute } from "@app/navigation/routes/_private/connect-two-fa";
import { Route as OtpDeliveryRoute } from "@app/navigation/routes/_private/otp-delivery";
import { TwoFaConnector } from "@pages/two-fa";

export const Route = createFileRoute("/_private/two-fa-verify")({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      kind: z.enum(["authenticator", "menu", "resetCode"]).optional(),
    }),
  ),
});

function RouteComponent() {
  const router = useRouter();
  const { kind } = Route.useSearch();
  const navigate = useNavigate();
  const handleGoSetupTwoFa = useCallback(async () => {
    await navigate({
      to: ConnectTwoFaRoute.fullPath,
    });
  }, [navigate]);
  const handleGoOtpDelivery = useCallback(async () => {
    await navigate({
      to: OtpDeliveryRoute.fullPath,
    });
  }, [navigate]);
  const handleGoToResetTotp = useCallback(
    async (resetCode: string) => {
      await navigate({
        replace: true,
        search: {
          resetCode,
        },
        to: "/totp-reset",
      });
    },
    [navigate],
  );
  return (
    <TwoFaConnector
      kind={kind}
      onGoBack={router.history.back}
      onGoOtpDelivery={handleGoOtpDelivery}
      onGoSetupTwoFa={handleGoSetupTwoFa}
      onGoToResetTotp={handleGoToResetTotp}
    />
  );
}
